import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import FilmUtil from "../utils/FilmUtil";
import FilmActions from "../actions/FilmActions";
import UserStore from "../stores/UserStore";
import VirtualContentActions from "../actions/VirtualContentActions";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";

class FilmStore {
  constructor() {
    this.bindActions(FilmActions);

    this.state = {
      films: {},
      allFilms: [],
      isFetching: false,
      isEditing: null,
      isCreating: false,
      newFilmId: null,
      uploadingImageField: null
    };

    this.exportPublicMethods({
      getFilmById: this.getFilmById.bind(this),
      getFilmsForEventBucket: this.getFilmsForEventBucket.bind(this),
      getAllUserFilms: this.getAllUserFilms.bind(this)
    });
  }

  getFilmById(id) {
    return this.state.films[id];
  }

  getFilmsForEventBucket(id) {
    return values(this.state.films).filter(function (n) {
      return n.event_bucket === id;
    });
  }

  getAllUserFilms() {
    return values(this.state.allFilms);
  }

  onFetchAllForUser() {
    this.setState({ isFetching: true });
    FilmUtil.fetchAllForUser(UserStore.getState().apiKey)
      .then(data => {
        //FilmActions.updateAllFilms(data);  // why is this not working?
        this.setState({ allFilms: data });
        this.setState({ isFetching: false });
      })
      .catch(FilmActions.fetchFailed);
  }

  onFetchAllForEventBucket(eventBucket) {
    this.setState({ isFetching: true });
    FilmUtil.fetchAllForEventBucket(UserStore.getState().apiKey, eventBucket)
      .then(data => {
        FilmActions.updateFilms(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(FilmActions.fetchFailed);
  }

  onFetchAllForCreator() {
    this.setState({ isFetching: true });
    FilmUtil.fetchAllForCreator(UserStore.getState().apiKey)
      .then(data => {
        FilmActions.updateFilms(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(FilmActions.fetchFailed);
  }

  onFetchOne(id) {
    this.setState({ isFetching: true });
    FilmUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        FilmActions.updateFilm(id, data);
        this.setState({ isFetching: false });
      })
      .catch(FilmActions.fetchFailed);
  }

  onEdit(newData) {
    this.setState({ isEditing: newData.id });
    FilmUtil.edit(UserStore.getState().apiKey, newData.id, newData.values)
      .then(data => {
        FilmActions.updateFilm(newData.id, data);
        this.setState({ isEditing: null });
      })
      .catch(FilmActions.editFailed);
  }

  onEditImage({ id, field, file }) {
    this.setState({ uploadingImageField: field });
    FilmUtil.editImage(UserStore.getState().apiKey, id, field, file)
      .then(data => {
        FilmActions.updateFilm(id, data);
        this.setState({ uploadingImageField: null });
      })
      .catch(FilmActions.editFailed);
  }

  onDelete(id) {
    FilmUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        FilmActions.updateFilm(id, undefined);
      })
      .catch(FilmActions.editFailed);
  }

  onCreate(newData) {
    this.setState({ isCreating: true, newFilmId: null });

    FilmUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        FilmActions.updateFilm(data.id, data);
        this.setState({ isCreating: false, newFilmId: data.id });
      })
      .catch(FilmActions.editFailed);
  }

  onInviteContentCreator({ id, email, options }) {
    FilmUtil.inviteContentCreator(
      UserStore.getState().apiKey,
      id,
      email,
      options
    )
      .then(data => {
        GlobalNotificationActions.notify.defer(
          `Content creator invitation sent successfully.`
        );
        FilmActions.fetchOne.defer(id);
      })
      .catch(FilmActions.editFailed);
  }

  onUpdateAllFilms(films) {
    this.setState({ allFilms: films });
  }

  onUpdateFilms(films) {
    this.setState({ films });
  }

  onUpdateFilm(data) {
    if (!data.film) {
      delete this.state.films[data.id];
    } else {
      this.state.films[data.id] = data.film;
      if (data.film.virtual_content) {
        VirtualContentActions.updateVirtualContent.defer(
          data.film.virtual_content.id,
          data.film.virtual_content
        );
      }
    }
    this.state.newFilmId = null;
    this.setState(this.state);
  }

  onFetchFailed(e) {
    alert(`Fetching films failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    alert(`Edit failed: ${e.message}`);
    this.setState({ isCreating: false, isEditing: false });
  }
}

export default alt.createStore(FilmStore, "FilmStore");



// WEBPACK FOOTER //
// ./src/app/stores/FilmStore.js